import { useState,useEffect } from 'react';
import styles from './singleTour.module.css'
import TableCm from "./TableCm";
import { BsCheckLg } from 'react-icons/bs';
const TableIndex = ({ tableArry , index }) => {
 console.log("tableArry", tableArry);
const allDay = ["حرکت", "اول", "دوم", "سوم", "چهارم", "پنجم", "ششم", "هفتم", "هشتم", "نهم", "دهم"];

  
  return (
    <div className={styles.table1Container} key={index} >
    <table className={`table mb-0 text-center ${styles.sotun2}`}>
      <thead>
        <tr >
          <th scope="col" className="topziro" style={{background:"#48935b",color:"#fff", borderRadius:"0px 18px 0 0px"}}>
           روز {allDay[index]}
          </th>
          <th scope="col" className={styles.thstyle} style={{background:"#48935b",color:"#fff", borderRadius:"0px 0 0 0"}}>
          
            مکان
           
          </th>
          <th scope="col" className={styles.thstyle} style={{background:"#48935b",color:"#fff", borderRadius:"18px 0 0 0"}}>
          
          توسط
          </th>
        </tr>
      </thead>
      <tbody className={styles.radif}>
      <tr>
          <td scope="row">گشت صبح</td>
          <td>
            {tableArry.reduce((total,item)=>{
              if (parseInt(item.type)==1 && parseInt(item.ispublic)==1 && item.title.trim() !=""){
                return item.title;
              }
              return total;
            }
            , "-")}
          </td>
          <td>
          {tableArry.reduce((total,item)=>{
              if (parseInt(item.type)==1 && parseInt(item.pre_price)>0 && parseInt(item.ispublic)==1){
                return <BsCheckLg/>;
              }
              return total;
            }
            , "-")}
         
          </td>
        </tr>
        <tr>
          <td scope="row">صبحانه</td>
          <td>
           
         
                {tableArry.reduce((total,item)=>{
              if (parseInt(item.type)==0 && parseInt(item.ispublic)==1 && item.Account_side_name.trim() !=""){
                return item.Account_side_name;
              }
              return total;
            }
            , "-")}
          </td>
          <td>
          
             {tableArry.reduce((total,item)=>{
              if (parseInt(item.type)==0 && parseInt(item.pre_price)>0 && parseInt(item.ispublic)==1){
                return <BsCheckLg/>;
              }
              return total;
            }
            , "-")}
          </td>
        </tr>
       
        <tr>
          <td scope="row"> ناهار</td>

          <td>
           
             {tableArry.reduce((total,item)=>{
              if (parseInt(item.type)==2 && parseInt(item.ispublic)==1 && item.Account_side_name.trim() !=""){
                return item.Account_side_name;
              }
              return total;
            }
            , "-")}
          </td>
          <td>
          
             {tableArry.reduce((total,item)=>{
              if (parseInt(item.type)==2 && parseInt(item.pre_price)>0 && parseInt(item.ispublic)==1){
                return <BsCheckLg/>;
              }
              return total;
            }
            , "-")}
          </td>
        </tr>
        <tr>
          <td scope="row">گشت عصر</td>
          <td>
          
             {tableArry.reduce((total,item)=>{
              if (parseInt(item.type)==3 && parseInt(item.ispublic)==1 && item.title.trim() !=""){
                return item.title;
              }
              return total;
            }
            , "-")}
          </td>
          <td>
         
            {tableArry.reduce((total,item)=>{
              if (parseInt(item.type)==3 && parseInt(item.pre_price)>0 && parseInt(item.ispublic)==1){
                return <BsCheckLg/>;
              }
              return total;
            }
            , "-")}
          </td>
        </tr>
        <tr>
          <td scope="row">شام</td>

          <td>
             {tableArry.reduce((total,item)=>{
              if (parseInt(item.type)==5 && parseInt(item.ispublic)==1 && item.Account_side_name.trim() !=""){
                return item.Account_side_name;
              }
              return total;
            }
            , "-")}
          </td>
          <td>
          
            {tableArry.reduce((total,item)=>{
              if (parseInt(item.type)==5 && parseInt(item.pre_price)>0 && parseInt(item.ispublic)==1){
                return <BsCheckLg/>;
              }
              return total;
            }
            , "-")}
          </td>
        </tr>
        <tr>
          <td scope="row">برنامه شب</td>
          <td>
          
            {tableArry.reduce((total,item)=>{
              if (parseInt(item.type)==6 && parseInt(item.ispublic)==1 && item.title.trim() !=""){
                return item.title;
              }
              return total;
            }
            , "-")}
          </td>
          <td>
            {tableArry.reduce((total,item)=>{
              if (parseInt(item.type)==6 && parseInt(item.pre_price)>0 && parseInt(item.ispublic)==1){
                return <BsCheckLg/>;
              }
              return total;
            }
            , "-")}
          </td>
        </tr>
        <tr>
          <td scope="row">اقامتگاه</td>

          <td>
          
            {tableArry.reduce((total,item)=>{
              if (parseInt(item.type)==7 && parseInt(item.ispublic)==1 && item.title.trim() !=""){
                return item.Account_side_name;
              }
              return total;
            }
            , "-")}
          </td>
          <td>
         
             {tableArry.reduce((total,item)=>{
              if (parseInt(item.type)==7 && parseInt(item.pre_price)>0 && parseInt(item.ispublic)==1){
                return <BsCheckLg/>;
              }
              return total;
            }
            , "-")}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
//     <div className='d-flex' >
//     {tableArry.map((table) => {
//     return <TableCm table={table} />;
//   })}</div>
  );
};

export default TableIndex;
